import { ReactComponent as BlueIconInfo } from '@/assets/svgs/blue-icon.svg';
import { ReactComponent as IconChevronDown } from "@/assets/svgs/chevron-down.svg";
import { ReactComponent as IconRequestDocument } from '@/assets/svgs/document-request.svg';
import { ReactComponent as IconInformation } from '@/assets/svgs/i.svg';
import { ReactComponent as IconTick } from '@/assets/svgs/tick.svg';
import Button from "@/components/Button/index";
import EnrollmentDropzone from '@/components/EnrollmentDropzone';
import Popover from '@/components/Popover';
import StatusLabel from "@/components/StatusLabel/index";
import Toast from '@/components/Toast';
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import { useBuildex } from "@/hooks/use-buildex/index";
import useModal from "@/hooks/use-modal/index";
import usePage from "@/hooks/use-page";
import usePersonas from '@/hooks/use-personas';
import useSGTDEnrollmentRequest from "@/hooks/use-sgtd-enrollment-request/index";
import useToast from '@/hooks/use-toast';
import { useParams } from "@/lib/router-dom";
import api from '@/services/api/sgtdEnrollmentRequest.js';
import { getDexConfig } from "@/utils/get-dex-config";
import { getEnvAndDex } from "@/utils/get-env-and-dex";
import titleCase from '@/utils/title-case';
import classname from 'classnames';
import { produce } from "immer";
import { uniqBy } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from 'react-dom';
import { useFeature } from "@/hooks/use-feature/index.js";
import { renderUserEmailInline } from '@/utils/formatUserEmail';
import { featureConstant } from "@/constants/configuration/feature";
import { useTradex } from "@/hooks/use-tradex/index";
import { useHealthdex } from "@/hooks/use-healthdex/index";

const Page = () => {

	/*=================================================1
		General
	/================================================*/
	const isSoftDeleteUserEnabled = useFeature(featureConstant.SOFT_DELETE_USER);
	const { dex } = getEnvAndDex();
	const dexConfig = getDexConfig(dex);
	const isBuildex = useBuildex();
	const isTradex = useTradex();
	const isHealthdex = useHealthdex();

	const [pageTitle, setPageTitle] = useState(`${dexConfig.dexName} Enrolment Request`);
	usePage({ title: pageTitle });

	const{ requestId, useCaseId, orgId } = useParams()

	const status = {
		pending: "PENDING_APPROVAL",
		approve: "APPROVED",
		reject: "REJECTED",
		sign: "SIGN_DSA",
		requestInfo: "REQUEST_FOR_INFO"
	}

	const toastType = {
		success: "success",
		error: "error"
	}

	const actionType = {
		approve: "APPROVE",
		reject: "REJECT",
		info: "INFO",
		sign: "DSA"
	}

	const [dataAgreement, setDataAgreement] = useState(false)
	const [files, setFiles] = useState([])

	const [loading, setLoading] = useState(false)
	const [loadingMessage, setLoadingMessage] = useState(null)

	//================================================
	// Text Conversion
	//================================================

	function convertToDisplay(text){
		if (text === "DSA_REQUESTED") return "Sign DSA"
		if (text === "SIGN_DSA") return "Sign DSA"
		if (text === "INFO_REQUESTED") return "Request for Info"
		if (text === "PENDING") return "Pending Approval"

		const str = text?.split("_")
		return str?.map((str)=> titleCase(str)).join(" ")
	}

	//================================================*/
	// Modal
	//================================================*/
	const { visible: visibleConfirmation, show: showConfirmation, hide: hideConfirmation } = useModal();
	const { visible: visibleInfo, show: showInfo, hide: hideInfo } = useModal();

	const [action, setAction] = useState("")
	const [rejectReason, setRejectReason] = useState("")
	const [requestInfo, setRequestInfo] = useState("")

	/*=================================================
	  API
	/================================================*/

	const { toastList, addToastMessage } = useToast()
	const { items:personaList, fetch:fetchPersonaList, find, setItems:setPersonaList } = usePersonas()
	const { find:getRequest, items:requestItem, setItems:setRequestItem, error: errorRequestList, useCase, personaItems, setPersonaItems, getConfig, myInfoConfig} = useSGTDEnrollmentRequest();

	const getData = {
		useCaseId: useCaseId
	}

	const breadcrumbsItems = useMemo(() => {
		return [
			{
				label: '',
				link: `/`,
			},
			{
				label: 'Approval Requests',
				link: `/admin/approval-requests`
			},
			{
				label: `${dexConfig.dexName} Enrolment Request`,
				link: ``
			},
		]
	}, [dexConfig])

	useEffect(()=>{
		getConfig()
		getRequest(requestId)
		fetchPersonaList(getData)
	},[])

	useEffect(()=>{
		if (requestItem.status === status.approve && requestItem.user?.organization?.dataSharingUrl){
			return setDataAgreement(true)
		}

		setDataAgreement(false)
	},[requestItem])

	/*=================================================
	  myInfo Config
	/================================================*/

	function companyAppointment(value){
		const config = myInfoConfig?.companyAppointment?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	function companyStatus(value){
		const config = myInfoConfig?.companyStatus?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	function companyTypes(value){
		const config = myInfoConfig?.companyTypes?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	function countryOfIncorp(value){
		const config = myInfoConfig?.countryOfIncorp?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	function nationality(value){
		const config = myInfoConfig?.nationality?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	/*=================================================
	  Status Dropdown
	/================================================*/
	const[statusActive, setStatusActive] = useState(false)
	const[statusPlaceHolder, setStatusPlaceHolder] =useState("Select Status")

	const statusRef = useRef(null)

	const [ options, setOptions ] = useState(["Approved", "Request for Info", "Sign DSA", "Rejected"])

	useEffect(()=>{

		if (dataAgreement === false && files.length === 0){
			return setOptions(["Approved", "Request for Info", "Sign DSA", "Rejected"])
		}

		if (dataAgreement === true && files.length > 0){
			return setOptions(["Approved", "Request for Info", "Sign DSA", "Rejected"])
		}

		return setOptions(["Request for Info", "Sign DSA", "Rejected"])

	},[dataAgreement, files])

	const handleStatusSelected = (option) =>{
		setStatusPlaceHolder(option)
		setStatusActive(false)

		if (option === "Approved") return setAction("APPROVE")
		if (option === "Rejected") return setAction("REJECT")
		if (option === "Request for Info") return setAction("INFO")
		if (option === "Sign DSA") return setAction("DSA")
		return setAction("")
	}

	async function submitStatus(){

		if (statusPlaceHolder === "Select Status"){
			return
		}

		setStatusPlaceHolder("Select Status")
		setRejectReason("")
		setRequestInfo("")

		if (action === actionType.info ) return showInfo()

		if (action === actionType.approve || action === actionType.reject ) return showConfirmation()


		if (action === actionType.sign){
			setLoading(true)
			const [error, result] = await api.changeOrgAndAdminReqStatus(orgId, "DSA_REQUESTED", requestId)

			if (error) {
				return addToastMessage(error?.message, toastType.error)
			}
			setLoading(false)
			return getRequest(requestId)
		}
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleStatusClick)
		return () => {
			document.removeEventListener('mousedown', handleStatusClick)
		}
	}, [])

	function handleStatusClick(event) {
		if (!statusRef.current) {
			return
		}

		if (statusRef.current.contains(event.target)) {
			return
		}
		setStatusActive(false)
	}


	/*=================================================
	  Persona Selection
	/================================================*/

	const[personaActive, setPersonaActive] = useState(false)
	const[personaPlaceHolder, setPersonaPlaceHolder] = useState("Select Persona(s)")
	const[newPersona, setNewPersona] = useState({})

	const personaRef = useRef(null)

	function handleSelected(option){
		setPersonaPlaceHolder(option.name)
		setNewPersona({id:option.id, name:option.name, $selected: true})
		setPersonaActive(false)
	}

	const handleUpdatePersonaSelect = (item) => {

		if (requestItem?.status === status.approve || requestItem?.status === status.reject){
			return
		}

		const index = personaItems?.findIndex(persona => persona.id === item.id);
		const updatedItems = produce(personaItems, draft => {
			draft[index].$selected = !draft[index].$selected
		})

		setPersonaItems(updatedItems)
	}

	const Checkbox = ({selected, handleUpdateItemSelect, disabled})=>{
		const personaCheckBoxClass = classname({
			"enrolment-request__checkbox": true,
			"enrolment-request__checkbox-margin":true,
			"enrolment-request__checkbox--active": selected,
			"enrolment-request__checkbox--disabled": disabled
		})

		return(
			<div data-testid = 'checkbox-element' className={personaCheckBoxClass} onClick={handleUpdateItemSelect} >{selected? <IconTick /> : null}</div>
		)
	}

	function addPersona(){

		if (personaPlaceHolder==="Select Persona(s)"){
			return
		}

		const uniqPersona = uniqBy([...personaItems,newPersona],"id")
		setPersonaItems(uniqPersona)
		setPersonaPlaceHolder("Select Persona(s)")
	}

	useEffect(() => {
		document.addEventListener('mousedown', handlePersonaClick)
		return () => {
			document.removeEventListener('mousedown', handlePersonaClick)
		}
	}, [])


	function handlePersonaClick(event) {
		if (!personaRef.current) {
			return
		}

		if (personaRef.current.contains(event.target)) {
			return
		}
		setPersonaActive(false)
	}

	const dropdownBtnClass = classname({
		"enrolment-request__dropdown-btn": (requestItem?.status === status.approve || requestItem?.status === status.reject) ? false : true,
		"enrolment-request__dropdown-btn--disabled": (requestItem?.status === status.approve || requestItem?.status === status.reject) ? true : false,
	})

	/*=================================================
		Data Agreement Upload
	/================================================*/

	function handleDataAgreementSelect(){
		if (requestItem?.status === status.approve || requestItem?.status === status.reject){
			return
		}

		setDataAgreement(!dataAgreement)
	}

	function parentCallback(files){

		if (files){
			return setFiles(files)
		}

		setFiles([])
	}

	function errorCallBack(error){

		if(error){
			return addToastMessage(error, toastType.error)
		}

	}

	/*=================================================
		API Action Functions
	/================================================*/

	async function requestAction(){
		const enrolledPersona = personaItems?.filter(persona=> persona.$selected === true).map(persona => {
			return persona.id
		})
		if(loading){
			return
		}

		if (action === actionType.approve){

			setLoading(true)
			if(files.length > 0){
				setLoadingMessage("Getting Upload URL...")
				const [getUrlError, urlResult] = await api.getUrl( orgId, files , 'data-sharing-agreement')
				if (getUrlError) {
					setLoadingMessage(null)
					setLoading(false)
					return addToastMessage(getUrlError?.message, toastType.error)
				}
				setLoadingMessage("Uploading file to server...")
				const [uploadError, uploadResult] = await api.uploadFile( urlResult.uploadURL, files)
				if (uploadError) {
					setLoadingMessage(null)
					setLoading(false)
					return addToastMessage(uploadError?.message, toastType.error)
				}
				setLoadingMessage("Scanning file for virus...")
				const [savingError, savingResult] = await api.scanAndSave( urlResult.key, orgId, 'data-sharing-agreement')
				if (savingError) {
					setLoadingMessage(null)
					setLoading(false)
					return addToastMessage(savingError?.message, toastType.error)
				}
			}

			const payload = {
				"personaIds": enrolledPersona
			}

			const [error, result] = await api.changeOrgAndAdminReqStatus(orgId, "APPROVED", requestId, payload)

			setLoadingMessage(null)
			setLoading(false)

			if (error) {
				return addToastMessage(error?.message, toastType.error)
			}

			getRequest(requestId)
			return addToastMessage("You have successfully approved the request.", toastType.success)
		}

		if (action === actionType.reject){
			setLoading(true)
			const payload = {
				"comment": rejectReason.length > 0 ? rejectReason : " "
			}

			const [error, result] = await api.changeOrgAndAdminReqStatus(orgId, "REJECTED", requestId, payload)

			setLoading(false)
			if (error) {
				return addToastMessage(error?.message, toastType.error)
			}

			setRejectReason("")
			getRequest(requestId)
			return addToastMessage("You have rejected the request.", toastType.success)

		}

		if (action === actionType.info){
			setLoading(true)
			const payload = {
				"comment": requestInfo
			}

			const [error, result] = await api.changeOrgAndAdminReqStatus(orgId, "INFO_REQUESTED", requestId, payload)

			setLoading(false)
			if (error) {
				return addToastMessage(error?.message, toastType.error)
			}

			setRequestInfo("")
			return getRequest(requestId)

		}

	}

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						{dexConfig.dexName} Enrolment Request
					</div>
				</div>
			</div>
			<hr />

			<div className="layout-data-elements">
				<div className="layout-data-elements__left">
					<div className="layout-data-elements__block">
						<div className="enrolment-request-left__header">
							<div className="enrolment-request-left__header-icon"><IconRequestDocument /></div>
							<div className="enrolment-request-left__header-desc">
								<div className="enrolment-request__title">{requestItem?.user?.firstName}</div>
								{/* <div className="enrolment-request__title">{requestItem?.user?.firstName} {requestItem?.user?.lastName}</div> */}
								<div className="enrolment-request__title--normal">{moment(requestItem?.created).format("D MMM YYYY, h:mm A")}</div>
							</div>
						</div>
						<div className="enrolment-request-left__subheader">{`User has submitted a request for ${requestItem?.user?.organization?.name} to join ${dexConfig.dexName}. Please review the details:`}</div>
						<div className="enrolment-request-left__content">
							<div className="enrolment-request-left__title">Requestor</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Full Name</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.firstName}</div>
								{/* <div className="enrolment-request-left__info">{requestItem?.user?.firstName} {requestItem?.user?.lastName}</div> */}
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Email</div>
								<div className="enrolment-request-left__info">{isSoftDeleteUserEnabled ? renderUserEmailInline(requestItem?.user) : requestItem?.user?.email} </div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Mobile Number</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.mobileNumber}</div>
							</div>
						</div>

						<div className="enrolment-request-left__content">
							<div className="enrolment-request-left__title">Company Information</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Company Name</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.name}</div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Company Registration No./ UEN</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.uen}</div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Company Type</div>
								<div className="enrolment-request-left__info">{companyTypes(requestItem?.user?.organization?.companyType)}</div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Date of Incorporation</div>
								<div className="enrolment-request-left__info">{moment(requestItem?.user?.organization?.incorporationDate).format("D MMM YYYY")}</div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Country of Incorporation</div>
								<div className="enrolment-request-left__info">{countryOfIncorp(requestItem?.user?.organization?.countryofIncorporation)}</div>
							</div>
							{isTradex && <div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Company Status</div>
								<div className="enrolment-request-left__info">{companyStatus(requestItem?.user?.organization?.companyStatus)}</div>
							</div>}
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Company Registered Address</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.registeredAddress}</div>
							</div>
						</div>

						<div className="enrolment-request-left__content">
							<div className="enrolment-request-left__title">Appointments</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Name</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.appointmentName}</div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Nationality</div>
								<div className="enrolment-request-left__info">{nationality(requestItem?.user?.organization?.appointmentNationality)}</div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Email Address</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.appointmentEmail}</div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Mobile Number</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.appointmentMobile}</div>
							</div>
							<div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">Company Appointment</div>
								<div className="enrolment-request-left__info">{companyAppointment(requestItem?.user?.organization?.appointmentPosition)}</div>
							</div>
						</div>

					</div>
				</div>

				<div className="layout-data-elements__right">
					<div className="layout-enrolment-request__block">
						<div className="layout-enrolment-request__header">
							<div className="layout-enrolment-request__text">
								<div className="enrolment-request__title">
									Application Status
								</div>
							</div>
						</div>
						<div className="layout-enrolment-request__content">
							<div className="enrolment-request__title">
								Current Status
							</div>

							<div className="enrolment-request__selection-container">
								<div className="enrolment-request__status">
									<StatusLabel text={convertToDisplay(requestItem?.status)} itemStatus={requestItem?.status}/>
								</div>
								<div className="enrolment-request__title--small">
									Change the status of application
								</div>
							</div>

							<div className="enrolment-request__dropdown-container" ref={statusRef}>
								<Popover visible={statusActive}>
									<Popover.Trigger>
										<div className="enrolment-request__dropdown">
											<div className="enrolment-request__dropdown-placeholder">{statusPlaceHolder}</div>
											<div data-testid="status-option" className={dropdownBtnClass} onClick={()=>(requestItem?.status === status.approve || requestItem?.status === status.reject) ? setStatusActive(false) : setStatusActive(!statusActive)}><IconChevronDown/></div>
										</div>
									</Popover.Trigger>

									<Popover.Content>
										<div className="enrolment-request__dropdown-content">
											{options.filter(option => !((isBuildex || isHealthdex) && (option === "Request for Info" || option === "Sign DSA")))
											.map((option)=>(
												<div className="enrolment-request__dropdown-item" key={option} onClick={()=>{handleStatusSelected(option)}}>
												{option}
											</div>
											))}
										</div>
									</Popover.Content>
								</Popover>
								<Button full maxWidth="80" text="Submit" disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)} submit={() => submitStatus()}/>
							</div>
						</div>
					</div>

					{isTradex && <div className="layout-enrolment-request__block">
						<div className="layout-enrolment-request__header">
							<div className="layout-enrolment-request__text">
								<div className="enrolment-request__title--small">
									Use Case
								</div>
								<div className="enrolment-request__title">
									{useCase?.useCaseTitle}
								</div>
							</div>
						</div>
						<div className="layout-enrolment-request__content">
							<div className="enrolment-request__title">
								Selected Personas
							</div>
							<div className="enrolment-request__title--small">
								Add or remove relevant personas for the company
							</div>
							{requestItem?.organizationUseCases?.length !==0 && (
								<div className="enrolment-request__card">
									<div className="card-configure__icon enrolment-request__card-icon"><BlueIconInfo  className="enrolment-request__icon__blue"/></div>
									<div className="enrolment-request__title--small enrolment-request__title-custom" style={{marginTop:"-18px"}}>Enabled Agent - Principal Function</div>
								</div>
							)}
							{requestItem?.status===actionType.approve && (
								<div  className="enrolment-request__card">
								<div className="card-configure__icon enrolment-request__card-icon"><BlueIconInfo  className="enrolment-request__icon__blue"/></div>
								<div className="enrolment-request__title--small enrolment-request__title-custom">Transactions on behalf of external participants enabled.</div>
								</div>
							)}
							<div className="enrolment-request__selection-container">
								{personaItems?.map((item,index)=>{
									return(
										<div className="enrolment-request__selection" key={index}>
											<Checkbox selected={item.$selected} handleUpdateItemSelect={()=>handleUpdatePersonaSelect(item)} disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)}/>
											<div className="enrolment-request__desc">{item.name}</div>
										</div>
									)
							})}
							</div>
							<div className="enrolment-request__dropdown-container" ref={personaRef}>
								<Popover visible={personaActive}>
									<Popover.Trigger>
										<div className="enrolment-request__dropdown">
											<div className="enrolment-request__dropdown-placeholder">{personaPlaceHolder}</div>
											<div data-testid="persona-option" className={dropdownBtnClass} onClick={()=>(requestItem?.status === status.approve || requestItem?.status === status.reject) ? setPersonaActive(false) : setPersonaActive(!personaActive)}><IconChevronDown/></div>
										</div>

									</Popover.Trigger>
									<Popover.Content>
										<div className="enrolment-request__dropdown-content ">
											{personaList.map((option,index)=>(
												<div className="enrolment-request__dropdown-item" key={option.id} onClick={()=>{handleSelected(option)}}>
												{option.name}
											</div>
											))}
										</div>
									</Popover.Content>
								</Popover>
								<Button full maxWidth="60" text="Add" disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)} submit={() => addPersona()}/>
							</div>
						</div>
					</div>}

					{isTradex && <div className="layout-enrolment-request__block">
						<div className="layout-enrolment-request__header">
							<div className="layout-enrolment-request__text">
								<div className="enrolment-request__title">
									Data Sharing Agreement
								</div>
							</div>
						</div>
						<div className="layout-enrolment-request__content">
							<div className="enrolment-request__selection" >
								<Checkbox selected={dataAgreement} handleUpdateItemSelect={()=>handleDataAgreementSelect()} disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)}/>
								<div className="enrolment-request__desc"> I confirm that the participant has submitted their Data sharing agreement</div>
							</div>

							<EnrollmentDropzone maxFiles="1" accept=".pdf" parentCallback={parentCallback} errorCallback={errorCallBack} disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)}/>
						</div>
					</div>}
				</div>
			</div>

			<Modal visible={visibleConfirmation} variant="medium" close={hideConfirmation}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='DS__icon--fill'>
											<IconInformation />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{titleCase(action)} Request
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							{
								action === actionType.approve && (
									<div className="action-modal__text">
										Are you sure you want to proceed to approve this request?
									</div>
								)
							}
							{
								action === actionType.reject && (
									<>
										<div className="action-modal__text">
											Are you sure you want to reject this request? The requestor will be notified.
										</div>
										<textarea className="action-modal__rejection-textarea" placeholder="Reason for rejection (Optional)" onChange={(e)=> setRejectReason(e.target.value)}></textarea>
									</>
								)
							}
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button full maxWidth="78" text={action === actionType.approve? "Confirm" : "Reject"}
								submit={() => {
									hideConfirmation()
									requestAction()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={visibleInfo} variant="medium" close={hideInfo}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div >
											<IconInformation />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Request for Info
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="action-modal__text">
								Please specify what you require from the participant. An email will be sent to the requestor.
							</div>
							<textarea className="action-modal__rejection-textarea" placeholder="Information required (Mandatory)" onChange={(e)=> setRequestInfo(e.target.value)}></textarea>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button full maxWidth="80" text="Submit"
								submit={() => {
									hideInfo()
									requestAction()
								}}
								disabled={!(requestInfo.length > 0)}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
			<Toast toastList={toastList} />

			{
				loading && (
					ReactDOM.createPortal(
						<div className='modal white'>
								{
									loadingMessage && (
										<>
											<div className='loading' style={{flexDirection: 'column'}}>
												<img src="/img/loading.gif" />
												<p style={{color: 'white'}}>{loadingMessage}</p>
											</div>
										</>
									)
								}
								{
									!loadingMessage && (
										<>
											<div className='loading' >
												<img src="/img/loading.gif" />
											</div>
										</>
									)
								}

						</div>
						, document.body
					)
				)
			}
		</>
	);
};

export default Page;
